import React from 'react';
import {Button, Image, SIZES, Typography} from '@fupa/fupa-uikit';
import styled from 'styled-components';
import {selectFollowInfo} from 'app/components/follow/followHelper';
import {Dialog} from 'app/components/dialog/Dialog';

const Container = styled.div`
  display: flex;
  margin: ${SIZES['24']} 0;
  flex-direction: column;
  align-items: center;
  padding: 0 1rem;
`;

const ImageContainer = styled.div`
  margin-bottom: 1rem;
`;

const DeleteFollowingPrompt = ({entity, onResolve, onReject, open}) => {
  const handleCancel = () => {
    onReject();
  };

  const handleDelete = () => {
    onResolve(entity);
  };

  const {imageType, name} = selectFollowInfo[entity.entity](entity);

  const actionContent = (
    <>
      <Button justify='center' onClick={handleCancel} secondary text label='Abbrechen' />
      <Button justify='center' onClick={handleDelete} label='Nicht mehr folgen' />
    </>
  );

  return (
    <Dialog actionContent={actionContent} handleClose={handleCancel} open={open} title='Abonniert'>
      <Container>
        <ImageContainer>
          <Image entity={imageType} width={64} height={64} ratio='1:1' circle={true} eager={true} src={entity.image} />
        </ImageContainer>
        <Typography variant='subheading'>{name} nicht mehr folgen?</Typography>
      </Container>
    </Dialog>
  );
};

export {DeleteFollowingPrompt};
